import styled from "styled-components";
import { FloatingLabel } from "react-bootstrap";
import { styled as StyledM } from "@mui/material/styles";
import StepIcon, { stepIconClasses } from "@mui/material/StepIcon";
import StepConnector, { stepConnectorClasses } from "@mui/material/StepConnector";

export const AzStepIcon = StyledM(StepIcon)((theme) => ({
  "& .MuiStepIcon-text": {
    fill: "var(--primary-color)",
    fontFamily: "iranSans",
    fontSize: "var(--font-size-lg)",
    transform: "translateY(2px)",
  },
  [`&.${stepIconClasses.root}`]: {
    width: "32px",
    height: "32px",
    color: "var(--white-color)",
    border: "0.5px solid var(--primary-color)",
    borderRadius: "50%",
  },
  [`&.${stepIconClasses.active}`]: {
    color: "var(--primary-color)",
    border: 0,

    "& .MuiStepIcon-text": {
      fill: "var(--white-color)",
    },
  },
  [`&.${stepIconClasses.completed}`]: {
    color: "var(--primary-color)",
    border: 0,
    "& .MuiStepIcon-text": {
      fill: "var(--white-color)",
    },
  },
}));

export const AzStepConnector = StyledM(StepConnector)((theme) => ({
  [`&.${stepConnectorClasses.root}`]: {
    top: 17,
    left: "calc(50% + 20px)",
    right: "calc(-50% + 20px)",
    position: "absolute",
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: "var(--blue-color-dark)",
    borderTopWidth: "0.5px",
    borderTopStyle: "dashed",
  },
}));

export const StyledFloatingLabel = styled(FloatingLabel)`
  label {
    color: var(--text-color-muted);
    top: -4px;
    left: ${({ $rtl }) => $rtl && "initial"};
    right: ${({ $rtl }) => $rtl && 0};
  }
`;
